import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import {
  Container, Button, Form, Modal 
} from "react-bootstrap";
import ReactCodeInput from 'react-verification-code-input';
import FocusTrap from "focus-trap-react";
import http from "../../api/http-request";
import CloseIcon from "../../assets/images/close-icon.svg";
import QRCode from 'qrcode.react';
import CopyIcon from "../../assets/images/copy-icon.svg";

class ConfigureAuthenticatorPopup extends Component{
    constructor(props){
        super(props);
        this.verificationInputRef=React.createRef();
        this.state={
            screen:1,
            verificationCode:"",
            verificationPlaceholder:['0', '0', '0', '0', '0', '0', '0', '0'],
            responseData:props.responseData,
            verificationCodeError:"",
            alphaNumericCode:"",
            qrCodeUrl:""
        }
    }
    onCopyHandler = (e) =>{
        e.preventDefault();
        let code = document.getElementById('qrcode');
        code.select();
        code.setSelectionRange(0,99999);
        navigator.clipboard.writeText(code.value);
    }
    onContinueHandler = (e) =>{
      e.preventDefault();
      const dataStoreToken = localStorage.getItem("authToken");
      const bearer = 'Bearer ';
      const {responseData} =this.state;
      responseData.callbacks[0].input.value=0;
      console.log(responseData)
      http({
          url:"authenticate?service=ProfileAuthenticatorRegistration&authIndexType=service&authIndexValue=ProfileAuthenticatorRegistration",
          method:"POST",
          data:responseData
        },
        {
          Authorization:`${bearer}${dataStoreToken}`,
          "Accept-API-Version": "protocol=1.0,resource=2.1"
    
        }).then((res)=>{
          if(res.status ===200 && res.data && res.data.callbacks){
              if(res.data.callbacks[0].output[0].value.includes('Scan the QR code')){
                let splitCode = res.data.callbacks[2].output[0].value.split('=');;
                  this.setState({
                      screen:2,
                      responseData:res.data,
                      qrCodeUrl:res.data.callbacks[2].output[0].value,
                      alphaNumericCode:splitCode[1]
                  })
              }
          }else if(res.status === 200 && res.data && typeof res.data === 'string'){
          //   pageNotFound(res);
          }
        })

  }
    onNext = (e) =>{
        e.preventDefault();
        const dataStoreToken = localStorage.getItem("authToken");
        const bearer = 'Bearer ';
        const {responseData} =this.state;
        responseData.callbacks[3].input.value=0;
        http({
            url:"authenticate?service=ProfileAuthenticatorRegistration&authIndexType=service&authIndexValue=ProfileAuthenticatorRegistration",
            method:"POST",
            data:responseData
          },
          {
            Authorization:`${bearer}${dataStoreToken}`,
            "Accept-API-Version": "protocol=1.0,resource=2.1"
      
          }).then((res)=>{
            if(res.status ===200 && res.data && res.data.callbacks){
                if(res.data.callbacks[0].output[0].value==="Enter verification code"){
                    this.setState({
                        screen:3,
                        responseData:res.data
                    })
                }
            }else if(res.status === 200 && res.data && typeof res.data === 'string'){
            //   pageNotFound(res);
            }
          })

    }
    onVerify = (e) =>{
        e.preventDefault();
        const dataStoreToken = localStorage.getItem("authToken");
        const bearer = 'Bearer ';
        const {responseData,verificationCode} =this.state;
        responseData.callbacks[0].input[0].value=verificationCode;
        this.verificationInputRef.current.__clearvalues__();
        http({
            url:"authenticate?service=ProfileAuthenticatorRegistration&authIndexType=service&authIndexValue=ProfileAuthenticatorRegistration",
            method:"POST",
            data:responseData
          },
          {
            Authorization:`${bearer}${dataStoreToken}`,
            "Accept-API-Version": "protocol=1.0,resource=2.1"
      
          }).then((res)=>{
            if(res.status ===200 && res.data && res.data.callbacks){
                if(res.data.callbacks[0].output[0].value==="Enter verification code"){
                    this.setState({
                        verificationCodeError:"pages.editNumberPopup.verificationCodeError"
                    })
                }
            }else if(res.status === 401 && res.code==="401" && res.message==="Login failure"){
                this.props.configuredAuthenticator("error")
            }else if(res.status === 200 && res.data.successUrl){
               this.props.configuredAuthenticator("success")
            }
          })

    }
    handleVerifyChange = (value) =>{
        this.setState({
            verificationCode:value
        })
    }
    render() {
        const {screen,verificationCodeError,verificationPlaceholder,qrCodeUrl,alphaNumericCode} = this.state;
        const {onClose,t} = this.props;
        // const {t} = useTranslation();

        return(
        <>
        <Modal
        show
        animation={false}
        onEscapeKeyDown={() => onClose()}
        aria-labelledby="authenticator-modal"
      >
        <FocusTrap>
          <div className="popup configure-authenticator">
            <Container fluid>
              <div className="popup__wrapper">
                <Form>
                  <div className="popup__wrapper-body">
                    <div className="popup__wrapper-body-header">
                      <h6 id="authenticator-modal">
                        {t("pages.profile.configureAuthenticator")}
                      </h6>
                      <Button
                        className="popup__wrapper-body-header-close"
                        onClick={() => {
                          onClose();
                        }}
                        variant="light"
                        aria-label="Close"
                      >
                        <img src={CloseIcon} alt="" />
                      </Button>
                    </div>
                    {screen === 1 && (
                      <>
                        {/* <p className="popup__wrapper-body-desc">
                          {t("pages.profile.authDescriptionOne")}
                        </p> */}
                        <ol className="twoFactor-desc popup__wrapper-body-desc">
                          <li>{t("pages.login.haveAppDescOne")}</li>
                          <li>{t("pages.login.haveAppDescTwo")}</li>
                        </ol>
                      </>
                    )}
                    {screen === 2 && (
                      <>
                        <ol className="popup__wrapper-body-desc">
                          <li>{t("pages.login.authDescriptionOne")}</li>
                          <li>{t("pages.login.authDescriptionTwo")}</li>
                          <li>{t("pages.login.authDescriptionThree")}</li>
                        </ol>
                        <div className="qrCode d-flex flex-column align-items-center justify-content-center mb-3">
                                <div className="my-4">
                                  <QRCode value={qrCodeUrl} className="desktop" size={256}/>
                                  <QRCode value={qrCodeUrl} className="mobile" size={156}/>
                                </div>
                                <div className="copyCode w-100 d-flex justify-content-center mb-4 gap-2">
                                  <input type="text" value={alphaNumericCode} disabled id="qrcode" className="mx-2"></input>
                                  <button onClick={e=>this.onCopyHandler(e)} title="Copy to Clipboard">
                                    <img src={CopyIcon} alt="Copy Icon" />
                                  </button>
                                </div>
                              </div>
                      </>
                    )}
                    {screen === 3 && (
                      <>
                        <div className="popup__wrapper-body-resend">
                          <p className="my-3">
                            {t("pages.profile.authOtp")}
                            <br />
                            {/* {mobileNumber} */}
                          </p>
                        </div>
                        <Form.Group controlId="verificationCode">
                          <Form.Label>
                            {t("pages.editNumberPopup.verificationCode")}
                          </Form.Label>
                          <ReactCodeInput
                            fields={6}
                            ref={this.verificationInputRef}
                            placeholder={verificationPlaceholder}
                            className={`verification-input
                            ${verificationCodeError ? "error-verification" : undefined}`}
                            onChange={this.handleVerifyChange}
                            removeDefaultStyles
                            autoFocus={false}
                          />
                        </Form.Group>
                        {verificationCodeError && (
                          <p className="error-text" id="verification-error">
                            {verificationCodeError && t(verificationCodeError)}
                          </p>
                        )}
                      </>
                    )}
                  </div>
                  <div className="popup__wrapper-footer">
                    {screen === 1 && (
                      <Button
                      className="wrapper__container-card-body-submit"
                      size="lg"
                      variant="primary"
                      block
                      type="submit"
                      onClick={(e) => this.onContinueHandler(e)}
                    >
                      {t("pages.identity.next")}
                    </Button>
                    )}
                    {screen === 2 && (
                      <Button
                        className="wrapper__container-card-body-submit"
                        size="lg"
                        variant="primary"
                        block
                        type="submit"
                        onClick={(e) => this.onNext(e)}
                      >
                        {t("pages.editNumberPopup.next")}
                      </Button>
                    )}
                    {screen === 3 && (
                      <Button
                        className="wrapper__container-card-body-submit"
                        size="lg"
                        variant="primary"
                        block
                        type="submit"
                        onClick={(e) => this.onVerify(e)}
                      >
                        {t("pages.editNumberPopup.verify")}
                      </Button>
                    )}
                  </div>
                </Form>
              </div>
            </Container>
          </div>
        </FocusTrap>
      </Modal>
        </>
        )
    }
}
ConfigureAuthenticatorPopup.propTypes = {
    t: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    verifyAppEnrolled:PropTypes.func.isRequired,
    configuredAuthenticator:PropTypes.func.isRequired
  };
export default withTranslation()(ConfigureAuthenticatorPopup);